/**
 *
 * Any data downloaded from the server and saved into
 * local or session STORAGE may not yet be downloaded
 * or stored at any point in the application.
 *
 * This module consolidates checks on and downloads
 * of that data
 *
 */

import * as getFetch from '../fetch/get.js'
import * as store from './store.js'
import * as routerUtilities from '../utilities/router.js'

const api = routerUtilities.getApi()

export async function getPortalLocation() {
    const portalLocation =
        store.getPortal() ?? (await fetchLocations().then((d) => d.portal))

    return portalLocation
}

export async function fetchLocations() {
    const endpoint = `${api}/locationLookup`

    const parameters = {
        url: window.location.hostname,
    }

    const data = await getFetch.getAFetch({ endpoint, parameters })

    const locationData = saveLocationData(data)

    return locationData
}

export async function getAllLocations() {
    const locations =
        store.getLocations() ??
        (await fetchLocations().then((d) => d.locations))
    return locations
}

/**
 * 
 * 
 * 
 * @returns 
 * 
 */
export async function initializeReportLocations() {
    const allLocations = await getAllLocations()
    const reportLocations = store.getReportLocations()

    const locations = allLocations.map((a) => {
        const id = a.locationID
        const name = a.feedyardName
        const idIndex =
            reportLocations !== null
                ? reportLocations.findIndex((r) => r.id === id)
                : -1

        // If an id does not exist, select it by default
        const isSelected =
            idIndex > -1 ? reportLocations[idIndex].isSelected : true

        return {
            id,
            name,
            isSelected,
        }
    })

    // TODO - centralize this - it is also copied in store.getReportLocations()
    locations.sort((a, b) =>
        a.name.localeCompare(
            b.name,
            navigator.languages[0] || navigator.language,
            {
                numeric: true,
                ignorePunctuation: true,
            }
        )
    )

    console.info({ reportLocations, locations, allLocations })

    store.setReportLocations(locations)

    return locations
}

export function getSelectedReportLocations() {
    const locations = store.getReportLocations()
    const selections = locations
        .filter((l) => l.isSelected === true)
        .map((l) => l.id)

    return selections
}

export function updateReportLocations({ locationId }) {
    const locations = store.getReportLocations()
    const indexToUpdate = locations.findIndex((x) => x.id === locationId)
    const isSelected = locations[indexToUpdate].isSelected
    locations[indexToUpdate].isSelected = !isSelected

    store.setReportLocations(locations)
}

export function saveLocationData(data) {
    console.group('save location data')
    console.info({ data })

    const portalLocation = data.locations.filter(
        (l) => l.locationID === data.masterLocationID
    )

    const id = portalLocation[0].locationID
    const name = portalLocation[0].portalName
    const phone = portalLocation[0].phone

    const portal = {
        id,
        name,
        phone,
    }

    store.setLocations(data.locations)
    store.setPortal(portal)

    console.groupEnd()

    return {
        locations: data.locations,
        portal,
    }
}

export function getAuthenticationToken() {
    const savedAuth = store.getAuthentication()

    if (savedAuth === null) return null

    const expiration = savedAuth?.expiration
    const token = isTokenAlive({ expiration }) ? savedAuth.token : null

    return token
}

/**
 *
 * @param {number} expiration epoch date
 */
function isTokenAlive({ expiration }) {
    if (expiration === null) return false

    const isAlive = new Date() < new Date(expiration)

    return isAlive
}

export async function getLastRefreshDate(){
	const primaryLocation = await getPortalLocation()
    const endpoint = `${api}/fetchLastDataRefreshDate`

    const parameters = {
        locationID: primaryLocation.id,
    }

    const lastRefreshDate = await getFetch.getAFetch({ endpoint, parameters, includeAuthorization: true })

	return lastRefreshDate
}

export async function getReportSelections(){	
	const primaryLocation = await getPortalLocation()
    const endpoint = `${api}/fetchReportSelections`

    const parameters = {
        locationID: primaryLocation.id,
    }

    const reportSelections = await getFetch.getAFetch({ endpoint, parameters, includeAuthorization: true })

	return reportSelections
}